import React from 'react'

const MaritalList = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="accordion-list">
                        <ul>
                            <li><i class="fa-solid fa-circle-check"></i>Single</li>
                            <li><i class="fa-solid fa-circle-check"></i>Married</li>
                            <li><i class="fa-solid fa-circle-check"></i>Divorced</li>
                            <li><i class="fa-solid fa-circle-check"></i>Widowed</li>
                            <li><i class="fa-solid fa-circle-check"></i>Living with a partner</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MaritalList